import { isArray, isFunction } from 'lodash'
import { getRowKeyIter } from '../../store/config/utils'
import { createExpandRowColumnCells } from '../../store/config/expand-row'
function isExpandable(treeProps, rowData, column, expandColumnKey, enableExpandRow) {
  const { children, hasChildren = 'hasChildren' } = treeProps
  return rowData[hasChildren] || (isArray(rowData[children]) && rowData[children].length > 0 && column.key === expandColumnKey) || enableExpandRow
}

export function createDynamicRow() {
  return {
    name: 'TableRow',
    props: {
      columns: Array,
      rowData: Object,
      renderDataIndex: Number,
      rowIndex: Number,
      _index: Number,
      loadingRow: Array,
      showSelection: Boolean,
      rowStyle: Object,
      rowKey: [String, Function],
      depthMap: Object,
      expandColumnKey: String,
      indentSize: Number,
      expandedRowKeys: Array,
      onRowExpanded: Function,
      treeProps: Object,
      fixedRowsLength: Number,
      rowHeight: Number,
      handleEvent: Function,
      dynamicSizeMap: Object,
      isMainTable: Boolean,
      enableExpandRow: Boolean,
      dynamicRowOffsetYMap: Object,
      scrollTop: Number,
      mainColumns: Array
    },
    computed: {
      currentSize () {
        const uniqueId = getRowKeyIter(this.$props.rowData, this.$props.rowKey)
        return this.$props.dynamicSizeMap[uniqueId] || 0
      },
      offsetY () {
        return this.dynamicRowOffsetYMap[this.$props.rowIndex]
      }
    },
    render(h) {
      const {
        columns = [],
        rowData = {},
        renderDataIndex,
        loadingRow,
        rowIndex,
        _index,
        showSelection,
        rowStyle,
        rowClassName = [],
        rowKey,
        depthMap,
        expandColumnKey,
        indentSize,
        iconSize,
        expandedRowKeys,
        onRowExpanded,
        treeProps,
        fixedRowsLength,
        rowHeight,
        isMainTable,
        enableExpandRow,
        // offsetY,
        scrollTop,
        mainColumns,
        // events
        handleEvent,
      } = this.$props

      const offsetY = this.offsetY
      // const _rowKeyVal = rowData[rowKey]
      const _rowKeyVal = getRowKeyIter(this.$props.rowData, this.$props.rowKey)
      const hasExpandRow = rowData._expandRowSign
      const depth = depthMap[_rowKeyVal] || 0
      const [$slots] = this.$slots.default || []
      const expandRow = $slots.expandRow
      let ColumnCells
      if (hasExpandRow && isMainTable) {
        // ColumnCells = <td colspan={mainColumns.length}>
        //   {
        //     expandRow({columns, rowData: rowData.expandRowData})
        //   }
        // </td>
        ColumnCells = createExpandRowColumnCells(h, {
          columns,
          mainColumns,
          currentSize: this.currentSize
        }, () => expandRow({columns, rowData: rowData.expandRowData}))
      } else {
        ColumnCells = columns && columns.map((column, columnIndex) => {
          const { placeholderSign } = column
          const currentSize = this.currentSize
          if (placeholderSign) {
            return $slots.cell({
              column,
              columnIndex,
              rowHeight,
              currentSize,
              offsetY,
              scrollTop
            })
          }
          const expandable = isExpandable(treeProps, rowData, column, expandColumnKey, enableExpandRow)
          return $slots.cell({
            column,
            columns,
            columnIndex,
            rowData,
            renderDataIndex,
            depth,
            rowIndex,
            loading: loadingRow.includes(_rowKeyVal),
            expandIconProps: expandable
              ? {
                rowData,
                rowIndex,
                onExpand: onRowExpanded,
              } : undefined,
            indentSize,
            iconSize,
            expandColumnKey,
            expandedRowKeys,
            rowKey,
            handleEvent,
            _index,
            showSelection,
            rowHeight,
            currentSize,
            offsetY,
            scrollTop
          })
        })
      }
      if ($slots.row) {
        ColumnCells = isFunction($slots.row) ? $slots.row({
          cells: ColumnCells.map((node) => {
            if (isArray(node) && node.length === 1) {
              return node[0]
            }
            return node
          }),
          style: rowStyle,
          columns,
          rowHeight
        }) : $slots.row
      }

      const index = rowIndex + (fixedRowsLength || 0)
      const mouseenter = ($event) => {
        handleEvent($event, { rowIndex: index, row: rowData, eventType: 'mouseenter', execRow: true })
      }
      const mouseleave = ($event) => {
        handleEvent($event, { rowIndex: index, row: rowData, eventType: 'mouseleave', execRow: true })
      }
      const rowClass = [
        'virtual-grid__inner__table__row',
        `row-depth-${depth}`,
        `row-${index}`,
        ...rowClassName
      ].filter(Boolean)
      return (
        <tr
          class={rowClass}
          style={rowStyle}
          onMouseenter={mouseenter}
          onMouseleave={mouseleave}
        >
          { ColumnCells }
        </tr>
      )
    },
    mounted () {
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver((entries) => {
          if (entries) {
            this.dispatchSizeChange(entries[0].target)
          }
        })
        this.resizeObserver.observe(this.$el)
      }
    },
    // since componet will be reused, so disptach when updated
    // updated() {
    // this.dispatchSizeChange()
    // },
    beforeDestroy () {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    },
    watch: {
      rowData () {
        this.$nextTick(() => {
          this.dispatchSizeChange(this.$el)
        })
      },
      currentSize (val) {
        // 增加对比的场景。在展开行（插入数据时）的场景，由于会触发整个虚拟列表的重新计算，所以，可能导致清空上一次计算的size结果。
        this.$nextTick(() => {
          const currentSize = this.getCurrentSize(this.$el)
          if (currentSize !== val) {
             this.dispatchSizeChange(this.$el)
          }
        })
      }
    },
    methods: {
      getCurrentSize (target) {
        return target ? target['offsetHeight'] : 0
      },
      // tell parent current size identify by unqiue key
      dispatchSizeChange (target) {
        const currentSize = this.getCurrentSize(target)
        const uniqueId = getRowKeyIter(this.$props.rowData, this.$props.rowKey)
        currentSize && this.$parent.$emit('row_resize', uniqueId, currentSize, this.$props.rowIndex)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/body/dynamic-row.js